var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative privacy-police-page content-page"},[_c('div',{staticClass:"px30 pt30"},[_c('router-link',{staticClass:"table",attrs:{"to":{
                path: '/login',
            }}},[_c('Close',{attrs:{"icon":"back"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"px30 py-8",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }